import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=d1da5fb2&scoped=true&v-show=isVisible&"
import script from "./Message.ts?vue&type=script&lang=ts&"
export * from "./Message.ts?vue&type=script&lang=ts&"
import style0 from "./Message.vue?vue&type=style&index=0&id=d1da5fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1da5fb2",
  null
  
)

component.options.__file = "Message.vue"
export default component.exports